import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVendorsList } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import formatDateAndTime from "../../common/formatDateAndTime";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import HeicPreview from "../../common/HeicPreview";
import { FileText, FileVideo, FileImage, File, Trash } from "lucide-react";
import ConfirmationModal from "../../common/Confirmationmodal";

function createData(
  attachments,
  workType,
  serviceDate,
  odoAtService,
  nextInspectionOdo,
  nextChangePredictedOdo,
  totalCost,
  notes,
  issueId,
  vendorId,
  createdAt,
  partId,
  partSource,
  brandName,
  serialNumber,
  partCost,
  partattachments,
) {
  return {
    attachments,
    workType,
    serviceDate,
    odoAtService,
    nextInspectionOdo,
    nextChangePredictedOdo,
    totalCost,
    notes,
    issueId,
    vendorId,
    createdAt,
    partId,
    partSource,
    brandName,
    serialNumber,
    partCost,
    partattachments,
  };
}

const steps = ["Service Log Details", "Clutch Part Details"];

const Clutchdetails = (
  { workOrderDetail, handleImageOpen },
  // { handleImageOpen, workOrderDetail }
) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const catalogValues = JSON.parse(localStorage.getItem("catalogValues"));

  const clutchPartName = catalogValues?.clutchPartName || {};
  delete clutchPartName?.inverted;
  const clutchPartSource = catalogValues?.clutchPartSource || {};
  delete clutchPartSource?.inverted;
  const clutchWorkType = catalogValues?.clutchWorkType || {};
  delete clutchWorkType?.inverted;
  const [activeStep, setActiveStep] = useState(0);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [clutchLogs, setClutchLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [myIssues, setMyIssuesDetails] = useState([]);
  const [serviceDetailsData, setServiceDetails] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteId, setDeleteId] = useState({ id: null, type: "" });
  const [editPartId, setEditPartId] = useState(null);
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const validation = [
    Number(workorderStatus?.inverted?.serviceCompleted),
    Number(workorderStatus?.inverted?.enrouteToHub),
    Number(workorderStatus?.inverted?.billingApproved),
    Number(workorderStatus?.inverted?.billingApprovalRequest),
  ].includes(Number(workOrderDetail?.serviceStatus));

  const handleDeleteCluthcDetails = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/clutchpartsdetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: deleteId?.id,
          isArchived: true,
        }),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Vehicle Service Part Deleted Successfully 🎉");
        setConfirmModal(false);
        setDeleteId({ id: null, type: "" });
        // setActiveTab("summary");
        await getClutchLog(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const parseImages = (value) => {
    try {
      if (!value) return [];

      // If already array → return as is
      if (Array.isArray(value)) return value;

      // If it's a string → parse it
      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      // If parsed is array → return
      if (Array.isArray(parsed)) return parsed;

      // If it's a single object → wrap in array
      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  const [form, setForm] = useState({
    serviceDetails: {
      clutchWorkType: null,
      serviceDate: null,
      odoAtService: null,
      vendorId: null,
      notes: null,
      issueId: null,
      attachments: [],
      totalCost: null,
    },
    parts: [
      {
        partId: null,
        partSource: null,
        brandName: null,
        serialNumber: null,
        attachments: [],
        cgst: null,
        sgst: null,
        discountAmount: null,
        discountPercentage: null,
        sgstPercentage: null,
        cgstPercentage: null,
        labourCost: null,
        totalCost: null,
        totalTax: null,
        totalTaxPercentage: null,
      },
    ],
  });

  const handleServiceAttachment = async (files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded;

    setForm((prev) => ({
      ...prev,
      serviceDetails: {
        ...prev.serviceDetails,
        attachments: [...(prev.serviceDetails.attachments || []), ...uploaded],
      },
    }));
  };

  const handlePartAttachment = async (index, files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded;

    const updated = [...form.parts];

    updated[index].attachments = [
      ...(updated[index].attachments || []),
      ...uploaded,
    ];

    setForm((prev) => ({
      ...prev,
      parts: updated,
    }));
  };

  const handleServiceChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      serviceDetails: {
        ...prev.serviceDetails,
        [field]: value,
      },
    }));
  };

  const handlePartChange = (index, field, value) => {
    const updated = [...form.parts];
    updated[index][field] = value;

    setForm((prev) => ({
      ...prev,
      parts: updated,
    }));
  };

  const grandTotal = Array.isArray(clutchLogs?.clutchPartsDetailsList)
    ? clutchLogs.clutchPartsDetailsList
        .filter((item) => item?.isArchived === false)
        .reduce((sum, row) => sum + Number(row?.totalCost || 0), 0)
    : 0;

  function ccyFormat(num) {
    return `${Number(num || 0).toFixed(2)}`;
  }

  const handleNext = async () => {
    const { serviceDetails } = form;

    // -------- Service Details Validation --------
    // if (!serviceDetails?.serviceDate) {
    //   return toast.error("Please select Service Date");
    // }

    // if (!serviceDetails?.odoAtService) {
    //   return toast.error("Please enter Odometer at Service");
    // }

    // if (!serviceDetails?.clutchWorkType) {
    //   return toast.error("Please select Clutch Work Type");
    // }

    // if (!serviceDetails?.issueId) {
    //   return toast.error("Please select Issue");
    // }

    // -------- Parts Validation --------
    // for (let i = 0; i < parts.length; i++) {
    //   const part = parts[i];

    //   if (!part.partId) {
    //     return toast.error(`Please select Part in row ${i + 1}`);
    //   }

    //   if (!part.partSource) {
    //     return toast.error(`Please select Part Source in row ${i + 1}`);
    //   }

    //   if (!part.brandName) {
    //     return toast.error(`Please enter Brand Name in row ${i + 1}`);
    //   }

    //   if (!part.serialNumber) {
    //     return toast.error(`Please enter Serial Number in row ${i + 1}`);
    //   }

    //   if (!part.partCost) {
    //     return toast.error(`Please enter Part Cost in row ${i + 1}`);
    //   }
    // }

    // -------- Payload --------
    const payload = {
      vehicleId: workOrderDetail?.vehicleId,
      serviceDate: workOrderDetail?.createdAt,
      odoAtService: serviceDetails?.odoAtService,
      workType: serviceDetails?.clutchWorkType,
      notes: serviceDetails?.notes,
      totalCost: serviceDetails?.totalCost,
      issueId: null,
      attachments: JSON.stringify(serviceDetails?.attachments),
      serviceLogId: workOrderDetail?.id,
    };

    try {
      const res = await fetch(`${apiUrl}/api/clutchservicelogs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Clutch Log Added Successfully 🎉");

        setForm({
          serviceDetails: {},
          parts: [
            {
              partId: "",
              partSource: "",
              brandName: "",
              serialNumber: "",
              partCost: "",
              attachments: [],
              totalCost: "",
              laborCost: "",
              discountAmount: "",
              discountPercentage: "",
              cgst: "",
              sgst: "",
              cgstPercentage: "",
              sgstPercentage: "",
              totalTax: "",
              totalTaxPercentage: "",
            },
          ],
        });
        setServiceDetails(data?.dataValues);
        setActiveStep(0);
        setActiveStep(activeStep + 1);
        // await getClutchPartDetails(workOrderDetail?.id);
      } else {
        toast.error(data?.msg);
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  const handleSubmit = async () => {
    const { parts } = form;

    const payload = {
      vehicleId: workOrderDetail?.vehicleId,
      serviceId: serviceDetailsData?.id || clutchLogs?.id,
      id: editPartId || undefined,
      partId: parts[0]?.partId,
      partSource: parts[0]?.partSource,
      brandName: parts[0]?.brandName,
      serialNumber: parts[0]?.serialNumber,
      attachments: JSON.stringify(parts[0]?.attachments),
      totalCost: parts[0]?.totalCost,
      labourCost: parts[0]?.laborCost,
      discountAmount: parts[0]?.discountAmount,
      discountPercentage: parts[0]?.discountPercentage,
      cgst: parts[0]?.cgstAmount,
      sgst: parts[0]?.sgstAmount,
      cgstPercentage: parts[0]?.cgstPercentage,
      sgstPercentage: parts[0]?.sgstPercentage,
      totalTax: parts[0]?.totalTax,
      totalTaxPercentage: parts[0]?.totalTaxPercentage,
      partCost: parts[0]?.partCost,
    };

    try {
      const res = await fetch(`${apiUrl}/api/clutchpartsdetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success(
          editPartId
            ? "Clutch Part Details Updated Successfully 🎉"
            : "Clutch Log Added Successfully 🎉",
        );

        setForm({
          serviceDetails: {},
          parts: [
            {
              partId: "",
              partSource: "",
              brandName: "",
              serialNumber: "",
              partCost: "",
              attachments: [],
              totalCost: "",
              laborCost: "",
              discountAmount: "",
              discountPercentage: "",
              cgstAmount: "",
              sgstAmount: "",
              cgstPercentage: "",
              sgstPercentage: "",
              totalTax: "",
              totalTaxPercentage: "",
            },
          ],
        });
        setEditPartId(null);
        await getClutchLog(workOrderDetail?.id);
        setActiveStep(1);
      } else {
        toast.error(data?.msg);
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (workOrderDetail?.id) {
      getClutchLog(workOrderDetail?.id);
    }
  }, [workOrderDetail]);

  const handleEdit = (row) => {
    setHideTestFields(true);
    setActiveStep(1);
    setEditPartId(row?.id || null);
    setForm((prev) => ({
      ...prev,
      parts: [
        {
          partId: row?.partId ?? "",
          partSource: row?.partSource ?? "",
          brandName: row?.brandName ?? "",
          serialNumber: row?.serialNumber ?? "",
          partCost: row?.partCost ?? "",
          attachments: parseImages(row?.attachments),
          totalCost: row?.totalCost ?? "",
          laborCost: row?.labourCost ?? row?.laborCost ?? "",
          discountAmount: row?.discountAmount ?? "",
          discountPercentage: row?.discountPercentage ?? "",
          cgstAmount: row?.cgstAmount ?? row?.cgst ?? "",
          sgstAmount: row?.sgstAmount ?? row?.sgst ?? "",
          cgstPercentage: row?.cgstPercentage ?? "",
          sgstPercentage: row?.sgstPercentage ?? "",
          totalTax: row?.totalTax ?? "",
          totalTaxPercentage: row?.totalTaxPercentage ?? "",
        },
      ],
    }));
  };

  const getClutchLog = async (id, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/clutchservicelogs?serviceLogId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setClutchLogs(data?.entities?.rows[0] || []);
        setTotalCount(data?.entities?.count || 0);
        if (data?.entities?.rows[0]?.workType) {
          setActiveStep(1);
        }
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp", "gif", "avif", "svg"].includes(ext))
      return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    if (ext === "heic") return "heic";
    if (["doc", "docx", "xls", "xlsx"].includes(ext)) return "doc";

    return "file";
  };

  const clutchParts = Array.isArray(clutchLogs?.clutchPartsDetailsList)
    ? clutchLogs.clutchPartsDetailsList.filter(
        (item) => item?.isArchived === false,
      )
    : clutchLogs?.clutchPartsDetailsList?.isArchived === false
      ? [clutchLogs.clutchPartsDetailsList]
      : [];

  return (
    <>
      <div className="flex justify-between p-6 mt-6">
        <h1 className="text-lg font-semibold">Add Clutch Details</h1>

        {hideTextfields ? (
          <CloseIcon
            onClick={() => setHideTestFields(false)}
            className="cursor-pointer"
          />
        ) : (
          <AddCircleOutlineIcon
            onClick={() => setHideTestFields(true)}
            className="cursor-pointer"
          />
        )}
      </div>

      {hideTextfields && (
        <div className="p-6">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* STEP 1 */}

          {activeStep === 0 && (
            <div className="grid grid-cols-3 gap-6 mt-6">
              <FormControl>
                <InputLabel>Clutch Work Type</InputLabel>
                <Select
                  value={form.serviceDetails.clutchWorkType}
                  label="Clutch Work Type"
                  onChange={(e) =>
                    handleServiceChange("clutchWorkType", e.target.value)
                  }
                >
                  {Object.entries(clutchWorkType).map(([k, v]) => (
                    <MenuItem key={k} value={k}>
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Service Interval (Odometer Limit)"
                value={form.serviceDetails.odoAtService}
                onChange={(e) =>
                  handleServiceChange("odoAtService", e.target.value)
                }
              />

              {/* <TextField
                label="Total Cost"
                value={form.serviceDetails.totalCost}
                onChange={(e) =>
                  handleServiceChange("totalCost", e.target.value)
                }
              /> */}

              <TextField
                label="Notes"
                value={form.serviceDetails.notes}
                onChange={(e) => handleServiceChange("notes", e.target.value)}
              />

              {/* <div className="col-span-3">
                <label className="font-semibold mb-2 block">
                  Service Attachments
                </label>

                <Button component="label" variant="outlined">
                  Upload Files
                  <input
                    hidden
                    type="file"
                    multiple
                    onChange={(e) => handleServiceAttachment(e.target.files)}
                  />
                </Button>
                <div className="flex gap-3 mt-3 flex-wrap">
                  {form.serviceDetails.attachments?.map((img, i) => (
                    <img
                      key={i}
                      src={img?.url}
                      className="w-20 h-20 object-cover rounded border"
                    />
                  ))}
                </div>
              </div> */}
            </div>
          )}

          {/* STEP 2 */}

          {activeStep === 1 && (
            <div className="p-2">
              <div className="space-y-4">
                {form.parts.map((part, index) => (
                  <div key={index} className="border rounded-lg p-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-end gap-4 mb-4">
                      {/* <h3 className="font-semibold">Part {index + 1}</h3> */}

                      {/* <div>
                        <Button
                          className="mt-4"
                          variant="outlined"
                          onClick={addPartRow}
                        >
                          + Add Part
                        </Button>
                        <Button
                          color="error"
                          size="small"
                          onClick={() => removePartRow(index)}
                        >
                          Remove
                        </Button>
                      </div> */}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <FormControl fullWidth>
                        <InputLabel>Part Name</InputLabel>

                        <Select
                          value={part.partId}
                          label="Part Name"
                          onChange={(e) =>
                            handlePartChange(index, "partId", e.target.value)
                          }
                        >
                          {Object.entries(clutchPartName).map(([k, v]) => (
                            <MenuItem key={k} value={k}>
                              {v}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel>Source</InputLabel>

                        <Select
                          value={part.partSource}
                          label="Source"
                          onChange={(e) =>
                            handlePartChange(
                              index,
                              "partSource",
                              e.target.value,
                            )
                          }
                        >
                          {Object.entries(clutchPartSource).map(([k, v]) => (
                            <MenuItem key={k} value={k}>
                              {v}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        label="Brand"
                        value={part.brandName}
                        onChange={(e) =>
                          handlePartChange(index, "brandName", e.target.value)
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="Part Cost"
                        value={part.partCost}
                        onChange={(e) =>
                          handlePartChange(index, "partCost", e.target.value)
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="Total Cost"
                        value={part.totalCost}
                        onChange={(e) =>
                          handlePartChange(index, "totalCost", e.target.value)
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="Labor Cost"
                        value={part.laborCost}
                        onChange={(e) =>
                          handlePartChange(index, "laborCost", e.target.value)
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="Discount Amount"
                        value={part.discountAmount}
                        onChange={(e) =>
                          handlePartChange(
                            index,
                            "discountAmount",
                            e.target.value,
                          )
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="Discount Percentage"
                        value={part?.discountPercentage}
                        onChange={(e) =>
                          handlePartChange(
                            index,
                            "discountPercentage",
                            e.target.value,
                          )
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="CGST Percentage"
                        value={part?.cgstPercentage}
                        onChange={(e) =>
                          handlePartChange(
                            index,
                            "cgstPercentage",
                            e.target.value,
                          )
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="SGST Percentage"
                        value={part?.sgstPercentage}
                        onChange={(e) =>
                          handlePartChange(
                            index,
                            "sgstPercentage",
                            e.target.value,
                          )
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="CGST Amount"
                        value={part?.cgstAmount}
                        onChange={(e) =>
                          handlePartChange(index, "cgstAmount", e.target.value)
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="SGST Amount"
                        value={part?.sgstAmount}
                        onChange={(e) =>
                          handlePartChange(index, "sgstAmount", e.target.value)
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="Total Tax"
                        value={part?.totalTax}
                        onChange={(e) =>
                          handlePartChange(index, "totalTax", e.target.value)
                        }
                      />

                      <TextField
                        fullWidth
                        type="number"
                        label="Total Tax Percentage"
                        value={part?.totalTaxPercentage}
                        onChange={(e) =>
                          handlePartChange(
                            index,
                            "totalTaxPercentage",
                            e.target.value,
                          )
                        }
                      />

                      <TextField
                        fullWidth
                        label="Serial Number"
                        value={part.serialNumber}
                        onChange={(e) =>
                          handlePartChange(
                            index,
                            "serialNumber",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="mt-5">
                      <p className="text-sm font-medium mb-2">Attachments</p>

                      <Button component="label" variant="outlined" size="small">
                        Upload Files
                        <input
                          hidden
                          type="file"
                          multiple
                          onChange={(e) =>
                            handlePartAttachment(index, e.target.files)
                          }
                        />
                      </Button>

                      {part.attachments?.length > 0 && (
                        <div className="flex gap-2 mt-3 flex-wrap">
                          {part.attachments.map((img, i) => (
                            <div
                              key={i}
                              className="w-20 h-20 border rounded overflow-hidden"
                            >
                              <img
                                src={img?.url}
                                alt={`attachment-${i}`}
                                className="w-full h-full object-cover"
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="flex justify-end gap-4 mt-6">
            {/* {activeStep > 0 && (
              <Button onClick={() => setActiveStep(activeStep - 1)}>
                Back
              </Button>
            )} */}

            {activeStep < steps.length - 1 && (
              <Button
                variant="contained"
                onClick={() => {
                  handleNext();
                }}
              >
                Next
              </Button>
            )}

            {activeStep === steps.length - 1 && (
              <Button variant="contained" onClick={handleSubmit}>
                Submit
              </Button>
            )}
          </div>
        </div>
      )}

      {confirmModal && (
        <ConfirmationModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          message={{
            title: "Confirm Deletion",
            content:
              "Are you sure you want to delete this vehicle service log Clutch Details?",
          }}
          handleConfirm={handleDeleteCluthcDetails}
        />
      )}

      <div className="p-2">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700, borderRadius: 10 }}>
            <TableHead>
              <TableRow>
                <TableCell>Clutch Work Type</TableCell>
                <TableCell>Service Date</TableCell>
                {/* <TableCell>Log Attachments</TableCell> */}
                <TableCell>Odometer At Service</TableCell>
                <TableCell>Part Name</TableCell>
                <TableCell>Part Source</TableCell>
                <TableCell>Brand</TableCell>
                <TableCell>Serial Num</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell>Attachment</TableCell>
                <TableCell align="right">Part Cost</TableCell>
                <TableCell align="right">Labor Cost</TableCell>
                <TableCell align="right">Discount Amount</TableCell>
                <TableCell align="right">Discount Percentage</TableCell>
                <TableCell align="right">GGST Amount</TableCell>
                <TableCell align="right">SGST Amount</TableCell>
                <TableCell align="right">CGST Percentage</TableCell>
                <TableCell align="right">SGST Percentage</TableCell>
                <TableCell align="right">Total Tax Percentage</TableCell>
                <TableCell align="right">Total Tax</TableCell>
                <TableCell align="right">Total Cost</TableCell>
                <TableCell align="right">Edit</TableCell>
                {/* <TableCell align="right">Delete</TableCell> */}
                {/* <TableCell align="right">Action</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {Array.isArray(clutchParts) &&
                clutchParts.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      {clutchWorkType[clutchLogs.workType] || "-"}
                    </TableCell>
                    <TableCell>{clutchLogs.serviceDate || "-"}</TableCell>
                    <TableCell>{clutchLogs.odoAtService || "-"}</TableCell>

                    <TableCell>{clutchPartName[row?.partId] || "-"}</TableCell>

                    <TableCell>
                      {clutchPartSource[row?.partSource] || "-"}
                    </TableCell>

                    <TableCell>{row?.brandName || "-"}</TableCell>

                    <TableCell>{row?.serialNumber || "-"}</TableCell>

                    <TableCell>{clutchLogs?.notes || "-"}</TableCell>

                    <TableCell>
                      {parseImages(row?.attachments)?.length > 0 ? (
                        <div className="grid grid-cols-4 gap-2">
                          {parseImages(row?.attachments).map((file, index) => {
                            const url =
                              file?.path || file?.url || file?.Location || file;

                            const type = getFileType(url);

                            return (
                              <div
                                key={index}
                                onClick={() => {
                                  handleImageOpen(
                                    file.url ||
                                      file?.path ||
                                      file?.Location ||
                                      file,
                                  );
                                }}
                                className="w-10 h-10 flex items-center justify-center border rounded-lg overflow-hidden cursor-pointer bg-gray-50"
                              >
                                {type === "image" && (
                                  <img
                                    src={url}
                                    alt="attachment"
                                    className="w-full h-full object-cover"
                                  />
                                )}

                                {type === "video" && (
                                  <video className="w-full h-full object-cover">
                                    <source src={url} />
                                  </video>
                                )}

                                {type === "pdf" && (
                                  <span className="text-xs text-red-500 font-semibold">
                                    PDF
                                  </span>
                                )}

                                {type === "doc" && (
                                  <span className="text-xs text-blue-500 font-semibold">
                                    DOC
                                  </span>
                                )}

                                {type === "other" && (
                                  <span className="text-xs text-gray-500">
                                    FILE
                                  </span>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.partCost)}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.labourCost)}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.discountAmount)}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.discountPercentage)}
                    </TableCell>

                    <TableCell align="right">{ccyFormat(row?.cgst)}</TableCell>

                    <TableCell align="right">{ccyFormat(row?.sgst)}</TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.cgstPercentage)}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.sgstPercentage)}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.totalTaxPercentage)}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.totalTax)}
                    </TableCell>

                    <TableCell align="right">
                      {ccyFormat(row?.totalCost)}
                    </TableCell>
                    {validation ? null : (
                      <TableCell>
                        {" "}
                        <Button
                          sx={{
                            color: "white",
                            bgcolor: "#1227e6",
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                            "&:hover": { bgcolor: "#0d1eb8" },
                          }}
                          onClick={() => handleEdit(row)}
                        >
                          Edit
                        </Button>
                      </TableCell>
                    )}
                    {/* {validation ? null : (
                      <TableCell align="right">
                        <button
                          type="button"
                          title="Delete"
                          className="text-red-500 hover:text-red-700"
                          onClick={() => {
                            setConfirmModal(true);
                            setDeleteId({
                              id: row?.id,
                              type: "clutch",
                            });
                          }}
                        >
                          <Trash size={24} />
                        </button>
                      </TableCell>
                    )} */}
                  </TableRow>
                ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableCell
                  colSpan={19}
                  align="right"
                  sx={{
                    fontWeight: 700,
                    fontSize: "16px",
                  }}
                >
                  Grand Total
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 700,
                    fontSize: "16px",
                  }}
                >
                  {ccyFormat(grandTotal)}
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default Clutchdetails;
